import { TranslatePipe } from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input, linkedSignal, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

import { SubscriptionType } from "../../apis/networkdashboard/graphql/graphql";
import { ServiceIcon } from "../../components/subscription-detail/service-icon/service-icon";
import { ApiHelper } from "../../helpers/apihelper";
import { AuthService } from "../../services/authservice";

@Component({
  selector: "[notificationSettingsRow]",
  templateUrl: "notification-settings-row.html",
  styleUrls: ["notification-settings-row.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule, ServiceIcon, TranslatePipe],
})
export class NotificationSettingsRowComponent {
  private api = inject(ApiHelper);
  private auth = inject(AuthService);
  private router = inject(Router);

  protected subscription = input.required<SubscriptionType>();
  private subscriptionId = computed(() => this.subscription().subscriptionId);

  protected impactSetting = linkedSignal(() => this.subscription().minimalImpactNotification ?? "Loss of Resiliency");
  protected inProgress = signal(false);

  protected description = computed(() => this.subscription().description);
  protected productTypeName = computed(() => this.subscription().product.type.toLowerCase());
  protected presentableName = computed(() => {
    const { customerDescription, description } = this.subscription();
    return customerDescription && customerDescription !== description ? customerDescription : "-";
  });
  protected isInfraverantwoordelijke = computed(() => this.auth.isInfraverantwoordelijke());

  protected async impactTypeChanged(impact: string) {
    this.impactSetting.set(impact);
    this.inProgress.set(false);
    try {
      const customerId = this.auth.viewingCustomer().customerId;
      await this.api.set_minimal_impact_notification(customerId, this.subscriptionId(), impact);
      this.inProgress.set(true);
    } catch (err) {
      Sentry.captureException(err);
    }
  }

  protected routeToService() {
    this.router.navigate([`/subscription/${this.subscriptionId()}`]);
  }
}
